import PageTabHeader from "@/components/BangXepHangByLeague/PageTabHeader";

/**
 * @param {object} props
 * @param {{ slug: string, vn: string }[]} props.continents
 * @param {string} props.activeSlug
 * @param {(slug: string) => void} props.onSelect
 */
export default function ContinentFilter({ continents, activeSlug, onSelect }) {
  const tabs = continents.map((c) => ({ id: c.slug, label: c.vn }));

  return (
    <div className="kbv-ltd-filter-block">
      <PageTabHeader
        tabs={tabs}
        activeTab={activeSlug}
        onTabChange={onSelect}
        variant="pill"
      />
    </div>
  );
}
